<div class="tds-row" style="margin-bottom: 40px;">
    <div class="tds-col-xxlg-3 tds-col-xlg-3 tds-col-lg-3 tds-col-md-0 tds-col-sm-0 tds-col-xs-0"></div>

    <div class="tds-col-xxlg-6 tds-col-xlg-6 tds-col-lg-6 tds-col-md-12 tds-col-sm-12 tds-col-xs-12">
        <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
             style="text-align: center;">
            <h4>{{ getLanguageItem('headercreatemeeting') }}</h4>
        </div>
        <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
             style="margin-top: 20px; display: flex; justify-content: center;">
            <tds-text-field [(ngModel)]="meetingName" label="{{getLanguageItem( 'titlemeetingname' )}}"
                            label-position="inside" ngDefaultControl no-min-width
                            placeholder="{{getLanguageItem( 'titlemeetingname' )}}" size="lg" state="default"
                            style="width: 400px;"
                            type="text">
            </tds-text-field>
        </div>
        <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
             style="margin-top: 20px; display: flex; justify-content: center;">
            <tds-button (click)="createMeeting()" [disabled]="isCreateDisabled()" size="md"
                        text="{{getLanguageItem( 'titlecreate' )}}"
                        type="button" variant="primary">
                <tds-icon name="edit" size="20px" slot="icon"></tds-icon>
            </tds-button>
        </div>
        @if (myMeetings.length > 0) {
                <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
                     style="margin-top: 20px">
                    <tds-divider orientation="horizontal"></tds-divider>
                </div>
                <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
                     style="text-align: center;">
                    <h2>{{ getLanguageItem('headermymeetings') }}</h2>
                </div>
                <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
                     style="text-align: center;">
                    <h4>{{ getLanguageItem('headercopyparticipantlink') }}</h4>
                </div>
                <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
                     style="text-align: center;">
                    <h4>{{ getLanguageItem('headerstartmeetingbuttonorcopymoderatorlink') }}</h4>
                </div>

                <div class="meeting-tabs-container">
                    <tds-folder-tabs (tdsChange)="onTabChange($event)">
                        <tds-folder-tab>
                        <span aria-controls="tab-panel" role="tab"
                              style="text-align: center">{{ getLanguageItem('foldertab1') }}</span>
                        </tds-folder-tab>
                        <tds-folder-tab>
                        <span aria-controls="tab-panel" role="tab"
                              style="text-align: center">{{ getLanguageItem('foldertab2') }}</span>
                        </tds-folder-tab>
                    </tds-folder-tabs>
                </div>

                <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
                     id="content-desktop"
                     style="max-width: 700px;margin: 0 auto">
                    <tds-table no-min-width responsive="true">
                        <tds-table-body>
                            @for (item of dataSource;track item.id) {
                            <tds-table-body-row>
                                <tds-body-cell>
                                    @if (!editDialogOpen) {
                                            <tds-popover-menu [attr.id]="'menu-' + item.id"
                                                              [attr.selector]="'.btn-trigger-' + item.id"
                                                              animation="none"
                                                              placement="bottom">
                                                <tds-popover-menu-item (click)="editMeeting(item)">
                                                    <button [attr.id]="'action-button-' + item.id">
                                                        <tds-icon name="edit"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem1') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                                @if (selectedTab === 'active') {
                                                        <tds-popover-menu-item (click)="archiveMeeting(item)">
                                                            <a>
                                                                <tds-icon name="folder"></tds-icon>
                                                                {{ getLanguageItem('popovermenuitem2') }}</a>
                                                        </tds-popover-menu-item>
                                                }

                                                @if (selectedTab === 'archive') {
                                                        <tds-popover-menu-item (click)="archiveMeeting(item)">
                                                            <a>
                                                                <tds-icon name="folder"></tds-icon>
                                                                {{ getLanguageItem('popovermenuitem3') }}</a>
                                                        </tds-popover-menu-item>
                                                }

                                            </tds-popover-menu>
                                        <tds-button aria-label="menu button" class="btn-trigger-{{item.id}}" only-icon
                                                    size="sm" variant="ghost">
                                            <tds-icon name="kebab" size="16px" slot="icon"></tds-icon>
                                        </tds-button>
                                    }
                                </tds-body-cell>
                                <tds-body-cell style="vertical-align: middle;">
                                    {{ item.name }}
                                </tds-body-cell>
                                <tds-body-cell>
                                    <tds-button (click)="startMeeting(item.key, item.moderatorKey)"
                                                [disabled]="selectedTab === 'archive'" size="sm"
                                                text="{{getLanguageItem( 'titlestartmeetingbutton' )}}"
                                                type="button"
                                                variant="secondary">
                                        <tds-icon name="send" size="16px" slot="icon"></tds-icon>
                                    </tds-button>
                                </tds-body-cell>

                                <tds-body-cell>
                                    @if (!qrDialogOpen) {
                                         <tds-popover-menu [attr.id]="'share-menu-' + item.id"
                                                              [attr.selector]="'.btn-share-trigger-' + item.id"
                                                              animation="none"
                                                              placement="bottom">
                                                <tds-popover-menu-item
                                                    (cdkCopyToClipboardCopied)="onCopied('participant')"
                                                    [cdkCopyToClipboard]="createMeetingLink(item.key)">
                                                    <button type="button">
                                                        <tds-icon name="copy"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem4') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                                <tds-popover-menu-item
                                                    (cdkCopyToClipboardCopied)="onCopied('moderator')"
                                                    [cdkCopyToClipboard]="createModeratorLink(item.key, item.moderatorKey)">
                                                    <button type="button">
                                                        <tds-icon name="copy"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem5') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                                <tds-popover-menu-item (click)="showQrCode(item)">
                                                    <button type="button">
                                                        <tds-icon name="dashboard"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem6') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                            </tds-popover-menu>
                                    }
                                    <tds-button [disabled]="selectedTab === 'archive'" aria-label="Share options"
                                                class="btn-share-trigger-{{item.id}}"
                                                only-icon size="sm" variant="ghost">
                                        <tds-icon name="share" size="16px" slot="icon"></tds-icon>
                                    </tds-button>
                                </tds-body-cell>

                                <!--                            <tds-body-cell id="pitem{{item.id}}"-->
                                <!--                                           [ngClass]="{ 'disabled-copy-group': selectedTab === 'archive' }"-->
                                <!--                                           style="vertical-align: middle;">-->

                                <!--                                <a class="wbt-spacing-right-8"-->
                                <!--                                   [style.cursor]="selectedTab === 'archive' ? 'not-allowed' : 'pointer'"-->
                                <!--                                   [cdkCopyToClipboard]="selectedTab === 'active' ? createMeetingLink(item.key) : null">-->
                                <!--                                    {{ getLanguageItem('titleparticipantlink') }}-->
                                <!--                                </a>-->

                                <!--                                <tds-icon name="copy"-->
                                <!--                                          size="20px"-->
                                <!--                                          [style.cursor]="selectedTab === 'archive' ? 'not-allowed' : 'pointer'"-->
                                <!--                                          [cdkCopyToClipboard]="selectedTab === 'active' ? createMeetingLink(item.key) : null">-->
                                <!--                                </tds-icon>-->

                                <!--                                <tds-tooltip-->
                                <!--                                    [selector]="'#pitem' + item.id"-->
                                <!--                                    [text]="selectedTab === 'active' ? getLanguageItem('titlecopy') : getLanguageItem('disabletitlecopy')">-->
                                <!--                                </tds-tooltip>-->

                                <!--                            </tds-body-cell>-->
                                <!--                            <tds-body-cell id="mitem{{item.id}}"-->
                                <!--                                           [ngClass]="{ 'disabled-copy-group': selectedTab === 'archive' }"-->
                                <!--                                           style="vertical-align: middle;">-->

                                <!--                                <a class="wbt-spacing-right-8"-->
                                <!--                                   [style.cursor]="selectedTab === 'archive' ? 'not-allowed' : 'pointer'"-->
                                <!--                                   [cdkCopyToClipboard]="selectedTab === 'active' ? createModeratorLink(item.key, item.moderatorKey) : null">-->
                                <!--                                    {{ getLanguageItem('titlemoderatorlink') }}-->
                                <!--                                </a>-->

                                <!--                                <tds-icon name="copy"-->
                                <!--                                          size="20px"-->
                                <!--                                          [style.cursor]="selectedTab === 'archive' ? 'not-allowed' : 'pointer'"-->
                                <!--                                          [cdkCopyToClipboard]="selectedTab === 'active' ? createModeratorLink(item.key, item.moderatorKey) : null">-->
                                <!--                                </tds-icon>-->

                                <!--                                <tds-tooltip-->
                                <!--                                    [selector]="'#mitem' + item.id"-->
                                <!--                                    [text]="selectedTab === 'active' ? getLanguageItem('titlecopy') : getLanguageItem('disabletitlecopy')">-->
                                <!--                                </tds-tooltip>-->

                                <!--                            </tds-body-cell>-->
                            </tds-table-body-row>
                            }

                        </tds-table-body>
                    </tds-table>
                </div>

                <div class="tds-col-xxlg-12 tds-col-xlg-12 tds-col-lg-12 tds-col-md-12 tds-col-sm-12 tds-col-xs-12"
                     id="content-mobile">
                    <tds-table no-min-width responsive="true">
                        <tds-table-header>
                            <tds-header-cell></tds-header-cell>
                            <tds-header-cell>Meeting name</tds-header-cell>
                            <tds-header-cell>Start meeting</tds-header-cell>
                            <tds-header-cell></tds-header-cell>

                            <!--                        <tds-header-cell>Meeting link</tds-header-cell>-->
                            <!--                        <tds-header-cell>Moderator link</tds-header-cell>-->
                        </tds-table-header>
                        <tds-table-body>
                            @for (item of dataSource;track item) {
                            <tds-table-body-row>
                                <tds-body-cell>
                                    @if (!editDialogOpen) {
                                            <tds-popover-menu [attr.id]="'menu-mobile-' + item.id"
                                                              [attr.selector]="'#mobile-menu-trigger-' + item.id"
                                                              placement="bottom-start">
                                                <tds-popover-menu-item (click)="editMeeting(mobilePopoverItem)">
                                                    <a>
                                                        <tds-icon name="edit"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem1') }}</a>
                                                </tds-popover-menu-item>
                                                @if (selectedTab === 'active') {
                                                        <tds-popover-menu-item (click)="archiveMeeting(item)">
                                                            <a>
                                                                <tds-icon name="folder"></tds-icon>
                                                                {{ getLanguageItem('popovermenuitem2') }}</a>
                                                        </tds-popover-menu-item>
                                                }
                                                @if (selectedTab === 'archive') {
                                                        <tds-popover-menu-item (click)="archiveMeeting(item)">
                                                            <a>
                                                                <tds-icon name="folder"></tds-icon>
                                                                {{ getLanguageItem('popovermenuitem3') }}</a>
                                                        </tds-popover-menu-item>
                                                }
                                            </tds-popover-menu>
                                    }
                                    <tds-button (click)="openMobilePopover(item)"
                                                [attr.id]="'mobile-menu-trigger-' + item.id" only-icon
                                                size="sm"
                                                variant="ghost">
                                        <tds-icon name="kebab" size="16px" slot="icon"></tds-icon>
                                    </tds-button>
                                </tds-body-cell>
                                <tds-body-cell style="vertical-align: middle;">
                                    {{ item.name }}
                                </tds-body-cell>
                                <tds-body-cell>
                                    <tds-button
                                        (click)="selectedTab === 'active' && startMeeting(item.key, item.moderatorKey)"
                                        [disabled]="selectedTab === 'archive'" size="sm"
                                        type="button"
                                        variant="secondary">
                                        <tds-icon name="send" size="16px" slot="icon"></tds-icon>
                                    </tds-button>
                                </tds-body-cell>
                                <tds-body-cell>
                                    @if (!qrDialogOpen) {
                                            <tds-popover-menu [attr.id]="'share-menu-mobile-' + item.id"
                                                              [attr.selector]="'.btn-share-trigger-mobile-' + item.id"
                                                              animation="none"
                                                              placement="bottom">
                                                <tds-popover-menu-item
                                                    (cdkCopyToClipboardCopied)="onCopied('participant')"
                                                    [cdkCopyToClipboard]="createMeetingLink(item.key)">
                                                    <button type="button">
                                                        <tds-icon name="copy"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem4') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                                <tds-popover-menu-item
                                                    (cdkCopyToClipboardCopied)="onCopied('moderator')"
                                                    [cdkCopyToClipboard]="createModeratorLink(item.key, item.moderatorKey)">
                                                    <button type="button">
                                                        <tds-icon name="copy"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem5') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                                <tds-popover-menu-item (click)="showQrCode(item)">
                                                    <button type="button">
                                                        <tds-icon name="dashboard"></tds-icon>
                                                        {{ getLanguageItem('popovermenuitem6') }}
                                                    </button>
                                                </tds-popover-menu-item>
                                            </tds-popover-menu>
                                    }
                                    <tds-button [disabled]="selectedTab === 'archive'" aria-label="Share options"
                                                class="btn-share-trigger-mobile-{{item.id}}"
                                                only-icon size="sm" variant="ghost">
                                        <tds-icon name="share" size="16px" slot="icon"></tds-icon>
                                    </tds-button>
                                </tds-body-cell>
                                <!--                            <tds-body-cell [ngClass]="{ 'disabled-copy-group': selectedTab === 'archive' }"-->
                                <!--                                           id="mobile-pitem-{{item.id}}"-->
                                <!--                                           style="vertical-align: middle;">-->
                                <!--                                <tds-icon-->
                                <!--                                    [cdkCopyToClipboard]="selectedTab === 'active' ? createMeetingLink(item.key) : null"-->
                                <!--                                    [style.cursor]="selectedTab === 'archive' ? 'not-allowed' : 'pointer'"-->
                                <!--                                    name="copy"-->
                                <!--                                    size="24px">-->
                                <!--                                </tds-icon>-->
                                <!--                                <tds-tooltip [selector]="'#mobile-pitem-' + item.id"-->
                                <!--                                             [text]="selectedTab === 'active' ? getLanguageItem('titlecopy') : getLanguageItem('disabletitlecopy')">-->
                                <!--                                </tds-tooltip>-->
                                <!--                            </tds-body-cell>-->
                                <!--                            <tds-body-cell [ngClass]="{ 'disabled-copy-group': selectedTab === 'archive' }"-->
                                <!--                                           id="mobile-mitem-{{item.id}}"-->
                                <!--                                           style="vertical-align: middle;">-->
                                <!--                                <tds-icon-->
                                <!--                                    [cdkCopyToClipboard]="selectedTab === 'active' ? createModeratorLink(item.key, item.moderatorKey) : null"-->
                                <!--                                    [style.cursor]="selectedTab === 'archive' ? 'not-allowed' : 'pointer'"-->
                                <!--                                    name="copy"-->
                                <!--                                    size="24px">-->
                                <!--                                </tds-icon>-->
                                <!--                                <tds-tooltip [selector]="'#mobile-mitem-' + item.id"-->
                                <!--                                             [text]="selectedTab === 'active' ? getLanguageItem('titlecopy') : getLanguageItem('disabletitlecopy')">-->
                                <!--                                </tds-tooltip>-->
                                <!--                            </tds-body-cell>-->
                            </tds-table-body-row>
                            }
                        </tds-table-body>
                    </tds-table>
                </div>
        }
    </div>
    <div class="tds-col-xxlg-3 tds-col-xlg-3 tds-col-lg-3 tds-col-md-0 tds-col-sm-0 tds-col-xs-0"></div>
</div>

@if (editDialogOpen) {
        <tds-modal
            actions-position="static"
            closable="false"
            header="{{getLanguageItem( 'modalheader1' )}}"
            prevent="true"
            show
            size="xs">
        <span slot="body">
        <tds-text-field
            [(ngModel)]="editName"
            id="editField"
            label="Meeting name"
            label-position="inside"
            ngDefaultControl
            size="sm">
        </tds-text-field>
        </span>
            <span slot="actions">
            <tds-button (click)="saveEditedMeeting()" class="wbt-spacing-right-8" data-dismiss-modal
                        size="md" text="{{getLanguageItem( 'modalbutton1' )}}"
                        variant="primary"></tds-button>
            <tds-button (click)="closeEditModal()" data-dismiss-modal size="md"
                        text="{{getLanguageItem( 'modalbutton2' )}}"
                        variant="secondary"></tds-button>
        </span>
        </tds-modal>
}

@if (qrDialogOpen) {
        <tds-modal actions-position="static" closable="false" header="{{getLanguageItem( 'qrmodalheader1' )}}"
                   prevent="true"
                   show size="sm">
    <span slot="body">
      <div class="qr-modal-body">
@if (qrDataUrl) {
    <img [src]="qrDataUrl" alt="QR Code" class="qr-image"/>
}
          @if (qrValue) {
              <div class="qr-link">{{ qrValue }}</div>
          }

    </div>
    </span>
            <span slot="actions">
              <div class="qr-modal-actions">
      <tds-button (click)="downloadQr()" class="wbt-spacing-right-8" size="md"
                  text="{{getLanguageItem( 'qrmodalbutton1' )}}"
                  variant="secondary"></tds-button>
      <tds-button (click)="copyQrImage()" size="md" text="{{getLanguageItem( 'qrmodalbutton2' )}}"
                  variant="secondary"></tds-button>
      <tds-button (click)="closeQrModal()" data-dismiss-modal size="md"
                  text="{{getLanguageItem( 'qrmodalbutton3' )}}"
                  variant="primary"></tds-button>
              </div>
    </span>
        </tds-modal>
}

@if (errMessage != '') {
    <div
        class="wbt-spacing-bottom-16 wbt-spacing-right-16"
        style="position: fixed; bottom: 0px; right: 0;">
        <tds-toast
            header="{{toastHeader}}"
            subheader="{{errMessage}}"
            variant="{{toastVariant}}">
        </tds-toast>
    </div>
}
@if (dataSource.length === 0) {
    <div class="empty-state">
        {{ getLanguageItem('nomeetingsmessage') }}
    </div>
}
